// RERARegistration.jsx
import React from "react";

export default function RERARegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            RERA Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            RERA Registration for Real Estate Projects & Agents
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists real estate developers and agents with
            RERA Registration, ensuring full compliance with the Real Estate
            (Regulation and Development) Act requirements across state portals.
          </p>
          <p className="text-gray-700">
            From project eligibility assessment and document structuring to
            online application filing, fee payments, and authority coordination,
            the registration process is managed systematically for timely
            approval and compliance.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/439391/pexels-photo-439391.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Real estate project RERA registration compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for RERA Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps developers and agents compile the
              comprehensive documentation required for RERA project and agent
              registrations on respective state portals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of promoter, company, or real estate agent.</li>
                <li>
                  Identity and address proof of applicant (Aadhaar, passport,
                  voter ID, or driving license).
                </li>
                <li>
                  Project details including layout plans, land ownership proofs,
                  approvals, and financial encumbrance certificates (for projects).
                </li>
                <li>
                  Registered office or business premises address proof (rent
                  agreement, ownership documents, or utility bills).
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized RERA compliance support with deep
              understanding of state-specific portals, documentation standards,
              and regulatory expectations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Real Estate Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Comprehensive knowledge of RERA Act provisions, state-wise
                  implementation variations, and documentation requirements for
                  both project promoters and real estate agents.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Regulatory Filings
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise application preparation, document organization, and
                  online submission across state RERA portals to minimize
                  objections and ensure swift approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end assistance from eligibility assessment through
                  filing, authority coordination, registration certificate
                  issuance, and ongoing quarterly compliance updates.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
